// removed by extract-text-webpack-plugin
module.exports = {"personMs":"personnelMessage_personMs_2Sn6Z","educationInfo":"personnelMessage_educationInfo_394AT","compensation":"personnelMessage_compensation_lcYRA","subTitle":"personnelMessage_subTitle_3EyxD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/baseInfo/personnelMessage/personnelMessage.scss
// module id = 606
// module chunks = 0